export default __webpack_public_path__ + "static/media/ranch-bottle.0fdd6f34.jpg";